import * as pdfjsLib from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Vite resolves the worker to a hashed asset URL in dev and build.
pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

/**
 * Load a PDF from an ArrayBuffer/Uint8Array. The bytes are copied because
 * pdf.js transfers (detaches) the buffer it is given.
 */
export async function loadPdf(data) {
  const bytes = data instanceof ArrayBuffer ? new Uint8Array(data.slice(0)) : new Uint8Array(data);
  return pdfjsLib.getDocument({ data: bytes }).promise;
}

export { pdfjsLib };
